import React, { useEffect } from 'react';
import { useDependente } from '../../../../contexts/InclusaoDependente/context';
import { useTitular } from '../../../../contexts/InclusaoTitular/context';
import Accordion from '../../../../components/Accordion';

import { LinkCardCustom } from '../../../../components/Cards/LinkCard';

import { PageContainer } from '../../../../styles/styles';

import * as S from './styles';

function EscolherTipo() {
    const { clearDependente } = useDependente();
    const { clearTitular, clearAlerts } = useTitular();

    useEffect(() => {
        clearDependente();
        clearTitular();
        clearAlerts();
    }, []);

    return (
        <PageContainer>
            <Accordion title="Escolha a modalidade que você quer adicionar:" hasCollapse={false} />

            <LinkCardCustom
                link="/movimentacao_cadastral/adicionar_titular"
                title="Titular"
                desc="Pessoa contratada pela empresa. Adicione dependente aqui também."
                icons={{ left: { name: 'person' } }}
            />

            <S.SpacingCards />

            <LinkCardCustom
                link="/movimentacao_cadastral/selecionar_titular"
                title="Dependente"
                desc="Pessoa ligada ao titular."
                icons={{ left: { name: 'group_add' } }}
                altImg="Adicionar Dependente"
            />
        </PageContainer>
    );
}

export default EscolherTipo;
